var map = {
	"./_0-COVER-fuvial.jpeg": 5642,
	"./_1-fluvial-florero-orinoco.png": 2858,
	"./_10-COVER-fuvial.png": 2806,
	"./_2-fluvial-ske.png": 6082,
	"./_3-fluvial-ske.png": 2446,
	"./_4-fluvial-orinoco.png": 9751,
	"./_5-fluvial-manacacias.png": 1733,
	"./_6-fluvial-juan-curi.png": 8311,
	"./_7-fluvial-coleccion.png": 410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7064;